import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Paper } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "400px",
    padding: theme.spacing(2),
  },
  message: {
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  link: {
    color: theme.palette.text.primary,
    textDecoration: "underline",
  },
}));

const BlockedView: React.FC = () => {
  const classes = useStyles();

  return (
    <Paper elevation={0} className={classes.root}>
      <Typography variant="h6" className={classes.message}>
        It looks like the report feature has been turned off by the admin.
        <br />
        Please{" "}
        <a
          href="https://bmkrs.atlassian.net/servicedesk/customer/portal/80"
          target="_blank"
          rel="noopener noreferrer"
          className={classes.link}
        >
          contact developers
        </a>{" "}
        to enable this feature for your namespace.
      </Typography>
    </Paper>
  );
};

export default BlockedView;
